import { Particle, type ParticleOptions } from "../Particle";
import { PhaseChange } from "../behaviors/PhaseChange";
import { HeatTransfer } from "../behaviors/HeatTransfer";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { Water } from "./Water";
import { adjustColor } from "../../utils/color";

export class Ice extends Particle {
    static baseColor = 0xA5F2F3; // Ice Blue

    constructor(options: Partial<ParticleOptions> = {}) {
        super({
            name: "Ice",
            color: adjustColor(Ice.baseColor, 10),
            behaviors: [
                new HeatTransfer(0.05), // 冰导热相对较慢
                new PhaseChange([
                    { temp: 4, type: 'above', factory: () => new Water({ temperature: 5 }) }
                ]),
                // 移除 TemperatureNormalization，使冰保持低温，不会自动回温融化
                // new TemperatureNormalization(20, 0.05) 
            ],
            props: { isLiquid: false },
            temperature: -20,
            minTemp: -273,
            maxTemp: 100,
            ...options
        });
    }
}
